export default __webpack_public_path__ + "static/media/alien.8603e323.png";